import { Page } from '@react-pdf/renderer';
import styled from 'styled-components';

export const ContainerPage = styled(Page)`
  width: 100%;
`;
